/**
 *
 * Menu
 *
 */

import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { StyledMenu } from './Menu.styles';

const Menu = ({
  arrow,
  marginBottom,
  children,
  fullWidthItems,
  hasSubmenu,
  ...props
}) => (
  <StyledMenu
    $arrow={arrow}
    $marginBottom={marginBottom}
    $fullWidthItems={fullWidthItems}
    $hasSubmenu={hasSubmenu}
    {...props}
  >
    {children}
  </StyledMenu>
);

Menu.propTypes = {
  arrow: PropTypes.bool,
  marginBottom: PropTypes.string,
  children: PropTypes.node,
  fullWidthItems: PropTypes.bool,
  hasSubmenu: PropTypes.bool,
};

export default memo(Menu);

export { default as MenuItem } from './MenuItem';
export { default as MenuItemStatic } from './MenuItemStatic';
export { default as Submenu } from './Submenu';
export { MenuData } from './Menu.styles';
